import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Polygon,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "12", r: "10", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Polygon,
          {
            points: "16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76",
            stroke: `${color}`
          }
        )
      ]
    }
  );
};
Icon.displayName = "Compass";
const Compass = memo(themed(Icon));
export {
  Compass
};
//# sourceMappingURL=compass.js.map
